import * as Yup from "yup";

export const ImportExcelSchema = Yup.object({
  file: Yup.mixed().required("Campo requerido"),
});
